import React from 'react'
import Home from './Home/Home'
import Keydates from './Keydates/Keydates'
import RegistrationFees from './RegistrationFees/RegistrationFees'
import AboutConference from './AboutConference/AboutConference'

const Main = () => {
    return (
        <div style={{display:'flex', flexDirection:'column', gap:'4rem'}}>
            <Home />
            <Keydates />
            <RegistrationFees />
            <AboutConference />
        </div>
    )
}

export default Main